// extracted by mini-css-extract-plugin
module.exports = {"content":"ResourceModal_content__yurvP","main":"ResourceModal_main__3aWby"};